import { deleteRequest, patchRequest } from 'services/requests';

const services = {
    updateFeedback: (id, body) => patchRequest(`/feedback/${id}`, body),
    deleteFeedback: (id) => deleteRequest(`/feedback/${id}`),
};

export default services;
